var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ServiceUnavailableError } from '@lucidlink/sdk/fetcher';
import { useLucidSdk } from '#context';
import { handleErrors } from './handleErrors';
import { useServiceUnavailableError } from './hooks/useServiceUnavailableError';
export const useWorkspaceAuthorization = () => {
    _react_refresh_temp_1();
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { workspaceId = '' } = useParams();
    const { lucidSdk } = useLucidSdk();
    const { handleServiceUnavailable } = useServiceUnavailableError();
    const handleCacheError = useCallback(async (error) => {
        // Currently handling this specific error outside of the established handleErrors function, as we'll probably move away
        // from one unified interface for error handlers to something more flexible.
        if (error instanceof ServiceUnavailableError) {
            handleServiceUnavailable();
            return;
        }
        try {
            // if you're looking for the map with errors and handlers it's next to handleErrors fn
            await handleErrors({
                error,
                params: {
                    queryClient,
                    lucidSdk,
                    navigate,
                    workspaceId,
                },
            });
        }
        catch (e) {
            // eslint-disable-next-line no-console -- Log
            console.error('Query error handling failed', e);
        }
    }, [
        handleServiceUnavailable,
        lucidSdk,
        navigate,
        queryClient,
        workspaceId,
    ]);
    /**
     * Globally intercepts query and mutation errors to handle authorization failures
     * (e.g., expired sessions, revoked permissions) with appropriate recovery actions.
     *
     * We filter on `action.type === 'error'` to react only when an error first occurs,
     * not on subsequent cache events where a stale error is still present in state.
     */
    useEffect(() => {
        const unsubscribeQueries = queryClient
            .getQueryCache()
            .subscribe((event) => {
            if (event.type === 'updated' && event.action.type === 'error') {
                void handleCacheError(event.query.state.error);
            }
        });
        const unsubscribeMutations = queryClient
            .getMutationCache()
            .subscribe((event) => {
            if (event.type === 'updated' && event.action.type === 'error') {
                void handleCacheError(event.mutation.state.error);
            }
        });
        return () => {
            unsubscribeQueries();
            unsubscribeMutations();
        };
    }, [handleCacheError, queryClient]);
};
_react_refresh_temp_1(useWorkspaceAuthorization, "9cHHTJE8Ii36H1eayTG7mxpvTg8=", false, () => [useQueryClient, useNavigate, useParams, useLucidSdk, useServiceUnavailableError]);
